
document.addEventListener('DOMContentLoaded', function () {
    var win_width = $(window).width();
    var win_height = $(window).height();
    var scrollmagic_offset = (win_height / 800) * 400;
    var controller_sec4 = new ScrollMagic.Controller();
    if (win_width > 1180) {
        var sec4_timeline = new TimelineMax();
        sec4_timeline
            .add([
                //TweenMax.to(".np-hp-imgbox", .5, {css: {  position: "fixed" },}),
                //TweenMax.to(".np-hp-imgbox", .5, {css: {  top: "0" },}),
                TweenMax.to('.np-hp-image', 5, { css: { transform: 'translateY(0) scale(1)' } }),
                TweenMax.to('.np-hp-image', 5, { css: { opacity: '1' } }),
            ])
            .add([TweenMax.to('.np-sec2-hp-desc-container', 3, { css: { opacity: '1' } })], '-=3');

        new ScrollMagic.Scene({ triggerElement: '#ct-4fid', duration: 1000, offset: scrollmagic_offset })
            .setTween(sec4_timeline)
            .setPin('#ct-4fid')
            .addTo(controller_sec4);
    } else {
        var sec4_timeline = new TimelineMax();
        sec4_timeline
            .add([
                TweenMax.to('.np-hp-image', 5, { css: { transform: 'translateY(0) scale(1)' } }),
                TweenMax.to('.np-hp-image', 5, { css: { opacity: '1' } }),
            ])
            .add([TweenMax.to('.np-hp-image', 3, { css: { opacity: '.5' } })])
            .add([TweenMax.to('.np-sec2-hp-desc-container', 3, { css: { opacity: '1' } })], '-=3');

        new ScrollMagic.Scene({ triggerElement: '#ct-4fid', duration: 1000, offset: scrollmagic_offset })
            .setTween(sec4_timeline)
            .setPin('#ct-4fid')
            .addTo(controller_sec4);
    }
});
